export enum RELEASE_TYPE {
  unknown = -1,
  single = 1,
  album = 2,
  minialbum = 3,
}

export enum SUBSCRIPTION_TYPE {
  unknown = -1,
  all = 1,
  ad = 2,
  subscription = 3,
}

export enum DELIVERY_STATUS {
  unknown = -1,
  notSend = 0,
  waiting = 1,
  inProgress = 2,
  published = 3,
  error = 4,
  canceled = 5,

  waitingForACKFile = 6,
  inProgressProcessingACKFile = 7,
  errorProcessingACKFile = 8,
  ACKFileError = 9,

  waitingForAssetIds = 10,
  inProgressAssigningAssetIds = 11,
  errorAssigningAssetIds = 12,

  withdrawWaiting = 13,
  withdrawInProgress = 14,
  withdrawn = 15,
  withdrawError = 16,

  unavailable = 17,
  publishWaiting = 18,

  waitingForAccept = 19,
  withdrawWaitingForAccept = 20,
}

export enum DELIVERY_METHOD {
  unknown = -1,
  Ddex382 = 0,
  Ddex43 = 1,
  Manual = 2,
}

export enum TRANSFER_METHOD {
  unknown = -1,
  Blob = 0,
  Ftp = 1,
  Sftp = 2,
}

export enum DIGITAL_PRODUCT_TYPE {
  unknown = -1,
  audio = 1,
  video = 2,
}
